<template>
  <van-popup
    v-model="visible"
    position="bottom"
    round
    closeable
    close-icon="close"
    style="min-height: 40%;"
  >
    <div class="record">
      <div class="title fs_18 mt_2 bold text_center mb_12">{{ title }}</div>
      <div class="record_wrap">
        
        <div class="record_item record_title">
          <div class="record_td bold record_left">{{ columns[0] }}</div>
          <div class="record_td bold record_mid">{{ columns[1] }}</div>
          <div class="record_td bold record_right">{{ columns[2] }}</div>
        </div>
        <div class="record_list">
          <van-empty
            v-if="noRecord"
            class="custom-image"
            :image="emptyImage"
            :description="emptyText"
          />
          <div v-for="it in list" :key="it.createTime" class="record_item">
            <div class="record_td record_left">{{ it.giftName }}</div>
            <div class="record_td record_mid">{{ it.createTime }}</div>
            <div class="record_td record_right">
              <div>{{ it.cdk }}</div>
              <span v-if="it.cdk" v-clipboard="it.cdk" class="fs_10 text_nowrap" style="color: #2B35FF">
                <i class="iconfont yw-copy fs_10"></i>复制
              </span>
              <span class="fs_10" style="color: #FF3000" v-else>
                领取失败
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Empty } from 'vant';

export default {
  name: 'RecordList',
  components: {
    [Popup.name]: Popup,
    [Empty.name]: Empty,
  },
  props: {
    // 标题
    title: {
      type: String,
      default: '领取记录'
    },
    // 空状态图片
    emptyImage: {
      type: String,
      default: 'https://static.hzwxbz3.cn/Lianyun/font_end/heziIOS/empty.png'
    },
    // 空状态文字
    emptyText: {
      type: String,
      default: '暂无数据'
    },
    // 表格列标题
    columns: {
      type: Array,
      default: () => ['惊喜名称', '领取时间', '惊喜码']
    },
    // 获取数据的 API 方法
    fetchApi: {
      type: Function,
      required: true
    },
    // API 参数
    apiParams: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false,
      list: [],
      noRecord: false,
    }
  },
  watch: {
    visible (val) {
      if (!val) {
        this.$emit('close')
      }
    },
  },
  methods: {
    triggerVisible(visible) {
      this.visible = visible;
      if (visible) {
        this.getList()
      }
    },
    getList() {
      this.fetchApi(this.apiParams).then(res => {
        this.list = res.data || []
        this.noRecord = !this.list.length
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.record {
  padding: 16px;
  .record_list {
    max-height: 320px;
    overflow: auto;
    padding: 6px 0;
    color: #616161;
  }
  .record_item {
    display: flex;
    align-items: center;
  }
  .record_title {
    padding-bottom: 6px;
    border-bottom: 1px #eee solid;
  }
  .record_td {
    width: 33%;
    text-align: center;
  }
  .record-title {
    padding-bottom: 12px;
    border-bottom: 1px solid #b7b7b7;
  }
  .record_item + .record_item {
    margin-top: 16px;
  }
  .fs_10 {
    font-size: 10px;
  }
}
</style> 